module.exports = __webpack_public_path__ + "media/images/weather/150_night-53290ad27b469c0759eb507f808e92f2.png";